<div class="row">
  <div class="large-3 columns alignment">
    <i class="material-icons  {{theme}}-color arrow"
       [style.color]="currentPageNumber === 0 ? 'Grey' : ''"
       [style.cursor]="currentPageNumber === 0 ? 'auto' : 'pointer'" (click)="previousPage()">arrow_backward</i>
  </div>
  <div class="large-3 columns alignment">
    <span>{{currentPageNumber + 1}} / {{totalNumberOfPages}}</span>
  </div>
  <div class="large-3 columns alignment">
    <i class="material-icons  {{theme}}-color arrow"
       [style.color]="currentPageNumber + 1 === totalNumberOfPages ? 'Grey' : ''"
       [style.cursor]="currentPageNumber + 1 === totalNumberOfPages ? 'auto' : 'pointer'"
       (click)="nextPage()">arrow_forward</i>
  </div>
  <div class="large-3 columns">
    <mat-select name="selectPageNumber"  id="pageSize" [(ngModel)]="pageSize" (change)="onChangePageSize($event.value)">
      <mat-option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</mat-option>
    </mat-select>
  </div>
</div>
